module.exports = __webpack_public_path__ + "static/media/pic_wf1.d7b991f3.png";